import { render, staticRenderFns } from "./WorkspaceSettings.view.vue?vue&type=template&id=a6196c84&scoped=true&"
import script from "./WorkspaceSettings.view.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSettings.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6196c84",
  null
  
)

export default component.exports